// Allows to preload static assets in order to cache them in service worker
import { Logger } from "@/logger";
import { AVAILABLE_FONTS } from "@/config/fonts";
// use generate static asset script to generate asset list and copy paste it
export const ASSET_LIST = [
  // images
  "/images/assets/culée.png",
  "/images/assets/developpe-buse.png",
  "/images/assets/mur-retour.png",
  "/images/assets/pile-trapézoïdale.png",
  "/images/assets/pont-dalle-extrados.png",
  "/images/assets/pont-dalle-intrados.png",
  "/images/assets/pont-à-poutres.png",
  "/images/assets/potence-2.png",
  "/images/assets/potence-3.png",
  "/images/assets/potence-renfort.png",
  "/images/assets/potence.png",
  "/images/assets/rectangle.svg",
  "/images/assets/tete-buse-standart-1.png",
  "/images/assets/tete-buse-standart.png",
  "/images/assets/tete-tunnel.png",
  "/images/illustrations/map.png",
  "/images/illustrations/report.png",
  "/images/org/ars.png",
  "/images/org/getec.png",
  "/images/org/pcm.png",
  "/images/org/sites.png",
  // Block icons
  "/icons/blocks/AAO.svg",
  "/icons/blocks/Amorce d'éclat.svg",
  "/icons/blocks/Concrétion-humide-1.svg",
  "/icons/blocks/Concrétion-sèche-1.svg",
  "/icons/blocks/Eclat 2 avec acier apparent.svg",
  "/icons/blocks/Eclat 2.svg",
  "/icons/blocks/Eclat avec acier apparent.svg",
  "/icons/blocks/Eclat.svg",
  "/icons/blocks/Flèche.svg",
  "/icons/blocks/Humidité.svg",
  "/icons/blocks/Point.svg",
  "/icons/blocks/Rejet.svg",
  "/icons/blocks/Rouille.svg",
  "/icons/blocks/Stalactite-humide-1.svg",
  "/icons/blocks/Stalactite-sèche-1.svg",
  "/icons/blocks/Stalactite.svg",
  "/icons/blocks/Végétation.svg",
  ...AVAILABLE_FONTS.map((fontInfo) => fontInfo.url),
];

// TypeError messages fetch() rejects with for network-level failures (offline,
// connection drop, DNS...), which vary by browser. Anything else is a real bug.
const NETWORK_ERROR_MESSAGES = new Set([
  "Failed to fetch", // Chrome, Edge
  "Load failed", // Safari
  "NetworkError when attempting to fetch resource.", // Firefox
]);

function isNetworkError(error: unknown): boolean {
  return error instanceof TypeError && NETWORK_ERROR_MESSAGES.has(error.message);
}

async function downloadFile(url: string): Promise<ArrayBuffer | undefined> {
  try {
    const response = await fetch(url, { method: "GET" });
    return await response.arrayBuffer();
  } catch (error) {
    if (!isNetworkError(error)) {
      Logger.captureException(error, { url });
      return undefined;
    }
    // Preloading is best-effort cache warming: a network hiccup on one asset
    // shouldn't surface as a crash report.
    Logger.warn(`Failed to preload asset ${url}: ${error}`);
    return undefined;
  }
}

/**
 * make sure the service worker is fully activated and ready before launching the preload
 * @param fn
 */
function loadOnServiceWorkerReady(fn: () => void) {
  return () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then(() => {
        setTimeout(() => {
          fn();
        }, 100);
      });
    }
  };
}

async function preloadPublicAssets(urls: string[]): Promise<void> {
  Promise.all(urls.map(async (url) => await downloadFile(url)));
}

async function preloadAssets() {
  Logger.info(`Preloading assets ...`);
  preloadPublicAssets(ASSET_LIST);
}

export default loadOnServiceWorkerReady(preloadAssets);

// uncomment this to test in dev assets are preloaded
//export default preloadAssets;
